/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

const ForgotForm = () => {
    return (
        <>
            <form name="contactForm" id='contact_form' class="form-border py-5" method="post" action='https://madebydesignesia.com/themes/gigaland/blank.php'>
                <h3>Forgot Password</h3>

                <div class="field-set">
                    <label>Email</label>
                    <input type='email' name='email'  class="form-control" placeholder="" />
                </div>
                <div className='pt-4'>
                    <input type='submit' id='send_message' value='Frogot' class="btn btn-main color-2 w-100" />
                </div>
                <div class="spacer-single"></div>

               


            </form>
        </>
    )
}

export default ForgotForm